module.exports = __webpack_public_path__ + "img/horizontal_3_2_9016.68fe9fa7.png";